import React from "react";

function SideFilter({ setSearchTerm }) {
  return (
    <div className="filter__container">
      <div className="search__bar">
        <input
          type="text"
          placeholder="Search"
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ width: "100%" }}
        />
      </div>
      <div>
        <div className="search__head">Search for</div>
        <div className="search__sub">
          <div>Mentors</div>
          <div>Investors</div>
          <div>Startups</div>
          <div>APIs</div>
        </div>
      </div>

      <div>
        <div className="search__head">Focus Area</div>
        <div className="search__sub">
          {[
            "Trading",
            "Banking",
            "Remittance",
            "Insurance",
            "Payments",
            "Wealth",
          ].map((cat, i) => (
            <div key={i} className="main__items">
              <input type="checkbox" id={cat} />{" "}
              <label htmlFor={cat}>{cat}</label>
            </div>
          ))}
        </div>
      </div>

      <div>
        <div className="search__head">Search for</div>
        <div className="search__sub">
          {["Chennai", "Mumbai", "Bangalore", "Kolkatta", "Punjab"].map(
            (place, i) => (
              <div key={i} className="location__items">
                <input type="checkbox" id={place} />{" "}
                <label htmlFor={place}>{place}</label>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
}

export default SideFilter;
